import * as React from "react";
import Typography from "@mui/material/Typography";

interface HeadingOneProps {
  children?: React.ReactNode;
}

export default function HeadingOne(props: HeadingOneProps) {
  return (
    <Typography variant="subtitle1" color="primary" gutterBottom>
      {props.children}
    </Typography>
  );
}
